
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebb31"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebb31"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $865207bb554b0b71$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["Y15zO","index.292e96b3.js","2YqCh","avatar.e3691842.png","3Oc4d","placeholderAvatar.ae5caa08.png","bplVL","ludoPlus.4361b87e.png","2p1H4","sheepFight.58085244.png","28ZXr","Knifehit.4c9eea4e.png","1gMDn","snake and ladders.4c80a1d6.png","k7olu","8ballpool.8fbe0b97.png","iUUJp","Carrom.b3a53bf7.png","fxV5Q","Bluff.fbcf7fbb.png","6EdkI","Basketball.64286c26.png","kGXgg","metalabLogo.f836824f.jpg","1tPDn","obverseCard.521c40e0.png","jXJIT","ewarLogo.2c138ee8.jpg","lDd6a","hereafterLogo.1a4f95f4.jpg","luxvO","gritbyteLogo.a0a8d734.jpg","8EB6Z","companyLogo.585eaf7c.jpg","2qFrF","c1s1.c50e3f6f.jpg","3U3Ao","c1s2.0ea95ba8.png","dJOiM","c1s3.3a845053.png","e5Rsn","c1s4.2d54b9c5.png","2mu6Q","c1s5.791e851d.png","lmMap","c1s6.8653cb79.png","1ouSe","c1s7.056a8793.png","9flkm","c1s8.e19e61c5.png","9A9we","c1s9.c0a69f97.png","70tqn","c1s10.e7c394d6.jpg","3jUKt","c1s11.60c392f0.jpg","dFyaH","c1s12.f11785fe.jpg","cjX8b","c1s13.3cb876fc.jpg","b7fRt","c1s14.5753445f.png","94dm2","c1o1.33a8f8ef.png","gOHdb","c1o2.e19e61c5.png","2JuBI","company1.697f7fb3.png","5211v","contribution1Slide1.79348e8e.png","2hAix","contribution1Output.7ac6adbb.jpg","avKdl","C3S1.076aa2a6.png","gWvwI","C4S1.fc6ae179.png","UBsWj","C4O1.d398bd73.png","bNp40","C5O1.dd092234.png","2GxRC","C5O2.da2db7c0.jpeg","5Jxke","C5O6.fe0bd831.jpeg","kXszW","C6O1.e6d23e2e.png","4YGdK","C6O2.49ad4c31.jpg","bTiqg","C6O3.56184d6e.png","2Fgt2","C7S1.aeef2cdd.png","KEgZ1","C7O1.bf7cc86a.png","gNhV2","C7O2.2fb30cb2.png","61Ksj","C7O3.34d6cf86.png","lBtYU","C7O4.b9c156fd.png","8O3zV","C8S1.4a4dcbb0.png","2hyxx","C8S2.d383a442.png","du3qq","C9S1.0d1df72d.png","hjiJD","C9O1.76bde05f.png","hp2O3","index.bd29ec70.css"]'));


//# sourceMappingURL=index.runtime.7527ce7e.js.map
